
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Earning from "./earning";
import TopItems from "@/components/topItems";
// import PurchaseVolume from './purchaseVolume'
import AccessHistory from "@/components/accessHistory";

import InactiveCustomers from "@/components/InactiveCustomers";


import OrdersStatus from "@/components/ordersStatus";
import Synchronization from "@/components/synchronization";
import ClaimReporting from "@/components/claim-reporting";
import MailInvoiceReporting from "@/components/MailInvoiceReporting";
// import Alerts from "@/components/alerts";
// import AlertsAuto from "@/components/alertsauto";
import SearchHistory from "@/components/search-history";
import SearchHistoryChartBar from "@/components/search-history-chart-bar";
import OrderLineHistory from "@/components/orderLineHistory"
import CustomerDeliveryNoteDownloadReporting from "@/components/customer-delivery-note-download-reporting";
// import InvoicesStatus from "@/components/invoicesStatus";
// import QuantityVolume from "./quantityPerTraderAndBrand.vue";
import ClientPerSupplier from "@/components/clientpersupplier";
import FtpImportedOrders from "@/components/ftpImportedOrders";
import ReportingApi from "@/services/reporting-api";
import ChanelDonut from "@/components/chanelDonut";
import ChanelChart from "@/components/chanelChart";
import ColumnChart from "@/components/column-chart"
import CustomersApi from "@/services/customers-api";

import PalierCustomer from "@/components/PalierCustomer"; 
import PalierCustomerNewUI from "@/components/PalierCustomerNewUi"; 

// import OrdersStatusCustomer from "@/components/ordersStatusCustomer";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { ChanelDonut,/*OrdersStatusCustomer,*/ChanelChart,ColumnChart,Layout,Earning,TopItems,/*PurchaseVolume,*/AccessHistory,
    OrdersStatus,Synchronization,SearchHistory,/**InvoicesStatus,*/ ClientPerSupplier, /*QuantityVolume,*/ 
    SearchHistoryChartBar,OrderLineHistory, CustomerDeliveryNoteDownloadReporting, /*Alerts, AlertsAuto*/ PalierCustomer, InactiveCustomers,ClaimReporting,
    PalierCustomerNewUI, MailInvoiceReporting, FtpImportedOrders},

    mounted(){

      if (this.isSupplier && !this.isAgencySupplier && this.agencyList.length > 0) {
        this.agencySelected = this.agencyList[0];
      } else {
        this.initReporting();
      }
      
      this.getCurrentMonthAndYear()
      var date = new Date();
      
      this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      //this.firstDay = new Date();
      const startoffset = this.firstDay.getTimezoneOffset()
      this.firstDay= new Date(this.firstDay.getTime() - (startoffset*60*1000))
      this.firstDay=this.firstDay.toISOString().split('T')[0]

      this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      //this.lastDay = new Date()
      const endoffset = this.lastDay.getTimezoneOffset()
      this.lastDay= new Date(this.lastDay.getTime() - (endoffset*60*1000))
      this.lastDay=this.lastDay.toISOString().split('T')[0]

  },

  computed: {
    envSupplierFullName(){
      return "Par " + process.env.VUE_APP_CLIENT_FULL_NAME
    },

    isNewPalierCustomerUI(){
      return process.env.VUE_APP_NEW_PALIER_CUSTOMER_NEW_UI === 'true';
    },

    customerFullName(){
      return process.env.VUE_APP_CLIENT_FULL_NAME
    },

    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },
    

    isCustomerDeliveryNoteDownloadEnabled(){
      return process.env.VUE_APP_FEATURE_CUSTOMER_BL_DOWNLOAD === 'true'
    },

    isClaimReportingEnabled(){
      return  process.env.VUE_APP_FEATURE_CLAIM_REPORTING === 'true'
    },

    isFtpImportedOrdersEnabled(){
      return  process.env.VUE_APP_FEATURE_FTP_IMPORTED_ORDERS === 'true'
    },

    isMailInvoiceReportingEnabled(){
      return  process.env.VUE_APP_FEATURE_MAIL_INVOICE_REPORTING === 'true'
    },

    role() {
      return this.$cookies.get('userr');
    },

    isSupplier() {
      return this.$cookies.get("userr") == 1;
    },

    isInactivecustomerReportEnabled(){
        return  process.env.VUE_APP_FEATURE_ENABLE_INACTIVE_CUSTOMERS_REPORT === 'true'
      },

    getThemeEnv(){
      return  process.env.VUE_APP_THEME
    },

    isParaOnly(){
      return  process.env.VUE_APP_FEATURE_PARA_ONLY === 'true'
    },

    filterByAgency() {
      return this.agencyList && this.agencyList.length > 1;
    },

    agencyList() {
      try {
        return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
      } catch (e) {
        return [];
      }
    },

    isAgencySupplier() {
      return this.$cookies.get('iss');
    },

  },

  data() {
    return {
      currentYear:null,
      currentMonth:null,

      privileges:"",
      isAdmin:false,
      hasReportingAccess:false,
      hasCustomersHistoryAcess:false,
      hasSynchronisationAccess:false,
      firstDay:null,
      lastDay:null,
      turnoverByWeekList:null,
      turnoverByMonthList:null,
      percentTurnoverList:null,
      turnoverByWeekListPharma:null,
      turnoverByMonthListPharma:null,
      percentTurnoverListPharma:null,

      customerLandingPharmaList:null,
      customerLandingParaList:null,

      customersList:[],

      agencySelected:null,


      turnoverByWeekKey:0,
      turnoverByMonthKey:0,
      percentTurnoverKey:0,
      turnoverByWeekKeyPharma:0,
      turnoverByMonthKeyPharma:0,
      percentTurnoverKeyPharma:0,
      customerLandingPharmaKey:0,
      customerLandingParaKey:0


    };
  },

  watch: {
    agencySelected(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initReporting()
      }
    },
  },

  methods: {

    initReporting(){
      this.getTurnoverByWeek()

      this.getTurnoverByMonth()

      this.getPercentTurnover()

      this.getPharmaTurnoverByWeek()
      
      this.getPharmaTurnoverByMonth()

      this.getPharmaPercentTurnover()

      this.getCustomerParaLanding();
      this.getCustomePharmaLanding();

    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          }
      )
    },

    getPharmaTurnoverByWeek(){
      const type = "PHARMA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getTurnoverByWeek(type, dbId).then(
          response => {
          this.turnoverByWeekListPharma=response;
          this.turnoverByWeekKeyPharma++
          this.turnoverByWeekListPharma.totalTurnover = response.totalTurnover.slice(-5);
          this.turnoverByWeekListPharma.turnoverByInternet = response.turnoverByInternet.slice(-5);
          this.turnoverByWeekListPharma.week = response.week.slice(-5);
          } 
      )
    },

    getPharmaTurnoverByMonth(){
      const type = "PHARMA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getTurnoverByMonth(type, dbId).then(
          response => {
          this.turnoverByMonthListPharma=response;
          this.turnoverByMonthKeyPharma++
          } 
      )
    },
    getPharmaPercentTurnover(){
      const type = "PHARMA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getPercentTurnover(type, dbId).then(
          response => {
          this.percentTurnoverListPharma=response;
          this.percentTurnoverKeyPharma++
        } 
      )
    },
    
    getTurnoverByWeek(){
      const type = "PARA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getTurnoverByWeek(type, dbId).then(
          response => {
          this.turnoverByWeekList=response;
          this.turnoverByWeekKey++

          this.turnoverByWeekList.totalTurnover = response.totalTurnover.slice(-5);
          this.turnoverByWeekList.turnoverByInternet = response.turnoverByInternet.slice(-5);
          this.turnoverByWeekList.week = response.week.slice(-5);
          } 
      )
    },

    getTurnoverByMonth(){
      const type = "PARA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getTurnoverByMonth(type, dbId).then(
          response => {
          this.turnoverByMonthList=response;
          this.turnoverByMonthKey++
          } 
      )
    },
    getPercentTurnover(){
      const type = "PARA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getPercentTurnover(type, dbId).then(
          response => {
          this.percentTurnoverList=response;
          this.percentTurnoverKey++
          } 
      )
    },
    getCurrentMonthAndYear(){
        var dt = new Date();
        this.currentMonth=dt.getMonth();
        this.currentYear  = dt.getFullYear();

          this.isAdmin= this.role == 1;
          this.hasReportingAccess= this.role == 1;
          this.hasCustomersHistoryAcess= this.role == 1;
          this.hasSynchronisationAccess= this.role == 1;
        
          this.isAdmin= this.role == 1;
          this.hasReportingAccess=true;
          this.hasCustomersHistoryAcess=true;
          this.hasSynchronisationAccess=true;
    },

    getCustomerParaLanding(){
      const type = "PARA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getCustomerLanding(type, dbId).then(
          response => {
          this.customerLandingParaList=response;
          this.customerLandingParaKey++
          } 
      )
    },
    
    getCustomePharmaLanding(){
      const type = "PHARMA"
      const dbId = this.agencySelected ? this.agencySelected.id : null
      ReportingApi.getCustomerLanding(type, dbId).then(
          response => {
          this.customerLandingPharmaList=response;
          this.customerLandingPharmaKey++
          } 
      )
    },

  }
};
</script>
<style>

  .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>
  <Layout>

  <div class="row  p-sm-4">
    <div class="col-12">
      <div v-if="role==1  && firstDay && lastDay">
        <b-tabs class="pb-4 pt-4"  fill justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
            <b-tab v-if="isAdmin || hasReportingAccess"  lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-chart-bar font-size-16 "/>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-chart-bar  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabSalesStats.title')}}</span>
              </template>

              <div v-if="this.isSupplier && !this.isAgencySupplier" class="col-12 mt-4">

                  <b-form-group v-if="this.filterByAgency"
                  :label="$t('lists.agency.filter')"
                  label-for="agency-filter"
                  >
                  <v-select
                      id="agency-filter"
                      class="style-vselect-big"
                      style="font-size:1.2em;"
                      :options="agencyList"
                      :placeholder="$t('lists.agency.label')"
                      label="name"
                      v-model="agencySelected"
                  >
                      <span slot="no-options">
                      {{$t('lists.emptyLists.label')}}
                      </span>
                  </v-select>
                  </b-form-group>

              </div>


              <div class="row mt-4">
                <div class="col-md-6 pr-md-4">
                  <Earning :isMonthly="true" 
                  :dbAgencyId=" this.agencySelected ? this.agencySelected.id : null" 
                  :currentMonth="new Date().getMonth()" 
                  :currentYear="new Date().getFullYear()" />
                </div>

                <div class="col-md-6">
                  <Earning :isYearly="true" 
                  :dbAgencyId=" this.agencySelected ? this.agencySelected.id : null" 
                  :currentMonth="new Date().getMonth()" 
                  :currentYear="new Date().getFullYear()"/>
                </div>
              </div>

               <!-- Paliers de remises -->
            <div v-if="isNewPalierCustomerUI" class="row">
                <div v-if="customerLandingPharmaList && role==0 " :key="this.customerLandingPharmaKey" class="col-12 col-md-6 pr-md-4 d-flex flex-column"  > 
                    <PalierCustomerNewUI v-if="customerLandingPharmaList" class="flex-grow-1" fill title="PHARMA : " 
                                :info="customerLandingPharmaList"
                    />
                </div>

                <div v-if="customerLandingParaList && role==0" :key="this.customerLandingParaKey" class="col-12 col-md-6 d-flex flex-column"  > 
                  <PalierCustomerNewUI v-if="customerLandingParaList" class="flex-grow-1" fill title="PARA : " 
                                :info="customerLandingParaList"
                    />
                </div>
              </div>


                <div v-else  class="row">
                  <div v-if="customerLandingPharmaList && role==0" :key="this.customerLandingPharmaKey" class="col-12 col-md-6 pr-md-4 d-flex flex-column"  > 
                    <PalierCustomer v-if="customerLandingPharmaList" class="flex-grow-1" title="PHARMA : " 
                                :info="customerLandingPharmaList"
                    />
                  </div>

                  <div v-if="customerLandingParaList && role==0" :key="this.customerLandingParaKey" class="col-12 col-md-6 d-flex flex-column"  > 
                    <PalierCustomer v-if="customerLandingParaList" class="flex-grow-1" title="PARA : " 
                                  :info="customerLandingParaList"
                    />
                  </div>
                </div>


<!-- Pharma -->

<div class="row mt-4">

  <!-- TMP -->
<div v-if="!isParaOnly" class="col-12 col-md-6 pr-md-4">
<div class="card h-100">
  <div class="card-body" v-if="this.turnoverByMonthListPharma" >
    <ColumnChart :key="this.turnoverByMonthKeyPharma" :dataTotal="this.turnoverByMonthListPharma.totalTurnover"  :data="this.turnoverByMonthListPharma.turnoverByInternet" 
    :categories="this.turnoverByMonthListPharma.month" 
    :firstName="this.customerPortalName" secondName="Total" title='PHARMA : Achats Mensuels'
     :labels="['Par Telephone' , this.envSupplierFullName ]"  />
  </div>
</div>      
</div>

<!-- TMP -->
<div :class="isParaOnly ? 'col-12' : 'col-12 col-md-6'" >
<div class="card h-100">
    <div class="card-body" v-if="this.turnoverByMonthList">
      <ColumnChart :key="this.turnoverByMonthKey" :dataTotal="this.turnoverByMonthList.totalTurnover"  :data="this.turnoverByMonthList.turnoverByInternet" 
      :categories="this.turnoverByMonthList.month" 
      :firstName="this.customerPortalName" secondName='Total' title="PARA : Achats Mensuels"
        :labels="[this.customerPortalName ,'Total' ]"  />
    </div>
 </div>     
</div>
</div>









<!-- para -->



<div class="row mt-4">
<div class="col-12 col-md-12">
  <div class="card  "> 
    <div class="card-body " v-if="this.turnoverByWeekListPharma">
      <ChanelChart :key="this.turnoverByWeekKeyPharma" :dataTotal="this.turnoverByWeekListPharma.turnoverByInternet"  :data="this.turnoverByWeekListPharma.totalTurnover" 
      :categories="this.turnoverByWeekListPharma.week" 
      firstName="Total" :secondName="this.customerPortalName" title='PHARMA : Achats par semaine'
        :labels="[this.customerPortalName ,'Total' ]"  />
    </div>
  </div>
</div>
</div>

<!-- TMP -->
<div v-if="isInactivecustomerReportEnabled" class="row mt-4">

<div class="col-12 col-md-12">
<div class="card  ">
<div class="card-body " v-if="this.turnoverByWeekList">
  <ChanelChart :key="this.turnoverByWeekKey" :dataTotal="this.turnoverByWeekList.turnoverByInternet"  :data="this.turnoverByWeekList.totalTurnover" 
  :categories="this.turnoverByWeekList.week " 
  firstName='Total' :secondName="this.customerPortalName" title='PARA : Achats par Semaine'
  :labels="[this.customerPortalName ,'Total' ]"  />
</div>
</div>
</div>
</div>


<div class="row mt-4">

<div v-if="!isParaOnly" class="col-12 col-md-6 pr-md-4">
<div class="card h-100" v-if="this.percentTurnoverListPharma">
<div class="card-body " >
<ChanelDonut :key="this.percentTurnoverKeyPharma" :data="this.percentTurnoverListPharma.percentTurnover" :labels="this.percentTurnoverListPharma.type" title="PHARMA : Répartition des canaux d'achats dans l'année courante" />

</div>

</div>
</div>

<div :class="isParaOnly ? 'col-12' : 'col-12 col-md-6'" >
<div class="card h-100" v-if="this.percentTurnoverList">
<div class="card-body " >
  <ChanelDonut :key="this.percentTurnoverKey" :data="this.percentTurnoverList.percentTurnover" 
  :labels="this.percentTurnoverList.type" title="PARA : Répartition des canaux d'achats dans l'année courante" />

</div>
</div>
</div>

</div>
              <!-- <div class="row mt-4">
                <div class="col-md-6 pr-md-4  ">
                  <div class="card h-100  m-2 ">
                    <div class="card-body p-0" >
                      <QuantityVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-4 pt-md-0 ">
                  <div class="card h-100 m-2 ">
                    <div class="card-body p-0">
                      <PurchaseVolume :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div> 
              </div>-->
              <div class="row mt-4">
                <div class="col-md-6 pr-md-4">
                  <div class="card h-100  ">
                    <div class="card-body p-0" >
                      <OrdersStatus :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-4 pt-md-0 ">
                  <div class="card h-100   ">
                    <div class="card-body p-0" >
                      <ClientPerSupplier :firstDay=this.firstDay :lastDay=this.lastDay :isCurrentMonthProp=true :isCurrentMonthProp2=true :isListPerCustomer=true />
                      <!-- <InvoicesStatus /> -->
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isFtpImportedOrdersEnabled" class="row mt-4">
                <div class="col-12">
                  <div class="card h-100">
                    <div class="card-body p-0">
                      <FtpImportedOrders :firstDay=this.firstDay :lastDay=this.lastDay :showCustomerFilter=true />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12  ">
                  <div class="card h-100  m-2 ">
                    <div class="card-body p-0" >
                    <TopItems :isReportingPage=true  :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>

            </b-tab>
            <b-tab v-if="isAdmin || hasCustomersHistoryAcess"  lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fa fa-history font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fa fa-history font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabHistory.title')}}</span>
              </template>


              <div class="row mt-4">
                <div class="col-md-6 pr-md-4">
                  <div class="card  ">
                    <div class="card-body p-0" >
                      <SearchHistoryChartBar :firstDay=this.firstDay :lastDay=this.lastDay  :isCustomerList="true" />
                    </div>
                  </div>
                </div>

                <div class="col-md-6 pt-4 pt-md-0">
                  <div class="card  ">
                    <div class="card-body p-0" >
                      <SearchHistoryChartBar :firstDay=this.firstDay :lastDay=this.lastDay  :isSupplierList="true" />
                    </div>
                  </div>
                </div>

              </div>


              <div class="row mt-4">
                <div class="col-12">
                  <div class="card  ">
                    <div class="card-body p-0" >
                      <SearchHistory :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12 ">
                  <div class="card  ">
                    <div class="card-body p-0">
                      <OrderLineHistory :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12 ">
                  <div class="card ">
                    <div class="card-body p-0">
                      <AccessHistory :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isInactivecustomerReportEnabled" class="row mt-4">
                <div class="col-12 ">
                  <div class="card ">
                    <div class="card-body p-0">
                      <InactiveCustomers :firstDay=this.firstDay :lastDay=this.lastDay  />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isCustomerDeliveryNoteDownloadEnabled" class="row mt-4">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body p-0">
                      <CustomerDeliveryNoteDownloadReporting :firstDay="firstDay" :lastDay="lastDay" />
                    </div>
                  </div>
                </div>
              </div>

            </b-tab>
            
            


            <!-- <b-tab v-if="isAdmin || hasSynchronisationAccess" lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-bell font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-bell font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">Alertes et Réclamations</span>
              </template>
              <div class="row pt-4">
                <div class="col-sm-12">
                  <div class="card  m-2 ">
                    <div class="card-body p-0">
                        <Alerts/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-4">
                <div class="col-sm-12">
                  <div class="card  m-2 ">
                    <div class="card-body p-0">
                        <AlertsAuto/>
                    </div>
                  </div>
                </div>
              </div>

            </b-tab> -->

            <b-tab v-if="isAdmin || hasSynchronisationAccess" lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-sync-alt  font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-sync-alt  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t('reporting.supplier.tabSynchro.title')}}</span>
              </template>
              <div class="row pt-4">
                <div class="col-sm-12">
                  <div class="card  ">
                    <div class="card-body p-0">
                          <Synchronization/>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="isClaimReportingEnabled && this.role == 1" lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-exclamation-circle font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-exclamation-circle  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16 text-uppercase">{{$t('reporting.supplier.tabClaimsState.title')}}</span>
              </template>
              <div class="row pt-4">
                <div class="col-sm-12">
                  <ClaimReporting/>
                </div>
              </div>
            </b-tab>

            <b-tab v-if="isMailInvoiceReportingEnabled && this.role == 1" lazy >
              <template v-slot:title>
                  <span class="d-inline-block d-md-none">
                  <i class="fas fa-envelope font-size-16"></i>
                  </span>
                  <i class="d-none d-md-inline-block fas fa-envelope font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16 text-uppercase">{{$t('reporting.supplier.tabMailInvoice.title')}}</span>
              </template>

                <div class="row pt-4">
                  <div class="col-sm-12">
                    <MailInvoiceReporting/>
                  </div>
                </div>
            </b-tab>

        </b-tabs>
      </div>

      <div v-if="role==0 && firstDay && lastDay">
        <div class="row mt-4">
        <div class="col-md-6 pr-md-4">
          <Earning :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
        </div>

        <div class="col-md-6">
          <Earning :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"  />
        </div>
      </div>


       <!-- Paliers de remises -->
            <div v-if="isNewPalierCustomerUI" class="row">
                <div v-if="!isParaOnly && customerLandingPharmaList && role==0 " class="col-12 col-md-6 pr-md-4 d-flex flex-column"  > 
                    <PalierCustomerNewUI v-if="customerLandingPharmaList" class="flex-grow-1" fill title="PHARMA : " 
                                :info="customerLandingPharmaList"
                    />
                </div>

                <div v-if="customerLandingParaList && role==0" class="d-flex flex-column" :class="isParaOnly ? 'col-12' : 'col-12 col-md-6 '"  > 
                  <PalierCustomerNewUI v-if="customerLandingParaList" class="flex-grow-1" fill title="PARA : " 
                                :info="customerLandingParaList"
                    />
                </div>
              </div>


                <div v-else  class="row">
                  <div v-if="!isParaOnly && customerLandingPharmaList && role==0" class="col-12 col-md-6 pr-md-4 d-flex flex-column"  > 
                    <PalierCustomer v-if="customerLandingPharmaList" class="flex-grow-1" title="PHARMA : " 
                                :info="customerLandingPharmaList"
                    />
                  </div>

                  <div v-if="customerLandingParaList && role==0" class="d-flex flex-column" :class="isParaOnly ? 'col-12' : 'col-12 col-md-6 '"  > 
                    <PalierCustomer v-if="customerLandingParaList" class="flex-grow-1" title="PARA : " 
                                  :info="customerLandingParaList"
                    />
                  </div>
                </div>

      <!-- Pharma -->

      <div class="row mt-4">

        <div v-if="!isParaOnly" class="col-12 col-md-6 pr-md-4">
          <div class="card h-100">
            <div class="card-body" v-if="this.turnoverByMonthListPharma" >
              <ColumnChart :dataTotal="this.turnoverByMonthListPharma.totalTurnover"  :data="this.turnoverByMonthListPharma.turnoverByInternet" 
              :categories="this.turnoverByMonthListPharma.month" 
              :firstName="this.customerPortalName" secondName="Total" title='PHARMA : Achats Mensuels'
               :labels="['Par Telephone' ,this.customerPortalName ]"  />
            </div>
          </div>      
        </div>

        <div :class="isParaOnly ? 'col-12' : 'col-12 col-md-6'" >
          <div class="card h-100">
              <div class="card-body" v-if="this.turnoverByMonthList">
                <ColumnChart :dataTotal="this.turnoverByMonthList.totalTurnover"  :data="this.turnoverByMonthList.turnoverByInternet" 
                :categories="this.turnoverByMonthList.month" 
                :firstName="this.customerPortalName" secondName='Total' title="PARA : Achats Mensuels"
                  :labels="[this.customerPortalName ,'Total' ]"  />
              </div>
           </div>     
        </div>
  </div>





     



      <!-- para -->

      

  
      <div class="row mt-4">
        <div v-if="!isParaOnly" class="col-12 " :class="getThemeEnv == 0 ? 'col-md-12' : 'col-md-6 pr-4'">
            <div class="card  "> 
              <div class="card-body " v-if="this.turnoverByWeekListPharma">
                <ChanelChart :dataTotal="this.turnoverByWeekListPharma.turnoverByInternet"  :data="this.turnoverByWeekListPharma.totalTurnover" 
                :categories="this.turnoverByWeekListPharma.week" 
                firstName="Total" :secondName="this.customerPortalName" title='PHARMA : Achats par semaine'
                  :labels="[this.customerPortalName ,'Total' ]"  />
              </div>
            </div>
        </div>

      <div   class="col-12"
          :class="{
            'col-md-6': !isParaOnly && getThemeEnv != 0,
            'col-md-12 mt-4': getThemeEnv == 0
          }">
        <div class="card  ">
          <div class="card-body " v-if="this.turnoverByWeekList">
            <ChanelChart :dataTotal="this.turnoverByWeekList.turnoverByInternet"  :data="this.turnoverByWeekList.totalTurnover" 
            :categories="this.turnoverByWeekList.week " 
            firstName='Total' :secondName="this.customerPortalName" title='PARA : Achats par Semaine'
            :labels="[this.customerPortalName ,'Total' ]"  />
          </div>
        </div>
      </div>
      </div>
      


      <div class="row mt-4">

<div v-if="!isParaOnly" class="col-12 col-md-6 pr-md-4">
  <div class="card h-100" v-if="this.percentTurnoverListPharma">
      <div class="card-body " >
        <ChanelDonut :data="this.percentTurnoverListPharma.percentTurnover" :labels="this.percentTurnoverListPharma.type" title="PHARMA : Répartition des canaux d'achats dans l'année courante" />

      </div>
        
  </div>
</div>

<div :class="isParaOnly ? 'col-12' : 'col-12 col-md-6'" >
  <div class="card h-100" v-if="this.percentTurnoverList">
          <div class="card-body " >
            <ChanelDonut :data="this.percentTurnoverList.percentTurnover" 
            :labels="this.percentTurnoverList.type" title="PARA : Répartition des canaux d'achats dans l'année courante" />

          </div>
        </div>
</div>

</div>
    
      <div class="row mt-4">
        
        <div class="col-md-12 pt-4 pt-md-0 ">
          <div class="card h-100  ">
            <div class="card-body p-0">

              <OrdersStatus :firstDay=this.firstDay :lastDay=this.lastDay /> 
            
              <!-- <OrdersStatusCustomer :firstDay=this.firstDay :lastDay=this.lastDay />  -->
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFtpImportedOrdersEnabled" class="row mt-4">
        <div class="col-md-12">
          <div class="card h-100">
            <div class="card-body p-0">
              <FtpImportedOrders :firstDay=this.firstDay :lastDay=this.lastDay />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12   ">
          <div class="card h-100  ">
            <div class="card-body p-0" >
            <TopItems :isReportingPage=true  :firstDay=this.firstDay :lastDay=this.lastDay  />
            </div>
          </div>
        </div>
        
      </div>

      </div>


    </div>
  </div>

  </Layout>
</template>

